<epc-auth-backdrop class="backdrop" [media]="bg$ | async"></epc-auth-backdrop>
<div class="route-container">
  <div class="w-100 text-center mb-4">
    <img
      class="logo img-fluid w-50"
      src="static/images/logo-login.png"
      alt="Brand logo"
      i18n-alt="AuthPage|Brand logo alt value@@authPageBrandLogoAlt"
    />
  </div>
  <router-outlet></router-outlet>
</div>

<atx-language-selector
  class="language-selector"
  [activeLanguage]="selectedLanguage$ | async"
  [languages]="availableLanguages$ | async"
  (selectLanguage)="setLanguage($event)"
></atx-language-selector>
